module.exports = __webpack_public_path__ + "static/media/slide-03.764af35f.jpg";